import { merge } from "@/utils/helpers.js";

export default class _MixinsCut {
  constructor(props) {
    merge(
      this,
      {
        last_stock: 0,
        min_people: 0,
        th: {
          adult_price: 3
        },
        sale: {
          adult_price: 4
        }
      },
      props
    );
  }
}
